const imomoVisibleFactory:ng.IDirectiveFactory = () => {
  return {
    restrict: 'A',
    multiElement: true,
    link: (scope:ng.IScope, element:ng.IAugmentedJQuery, attr:ng.IAttributes) => {
      scope.$watch(attr['imomoVisible'], function (visible:any) {
        angular.forEach(element, (node:HTMLElement) => {
          if (node.style) {
            node.style
                .setProperty('visibility', visible ? 'visible' : 'hidden');
          }
        });
      });
    }
  }
};
export default imomoVisibleFactory;



/** WEBPACK FOOTER **
 ** ./app/utils/imomo-visible.directive.ts
 **/